import { render, staticRenderFns } from "./HelperItems.vue?vue&type=template&id=23317816&scoped=true"
import script from "./HelperItems.vue?vue&type=script&lang=js"
export * from "./HelperItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23317816",
  null
  
)

export default component.exports